import { getUser } from "@utils";
import React from "react";
import { Content, ContentTitle } from "../baseItems";
import Base from "./base";

export default class Mefete extends Base {
	getStep1(translate) {
		const { selectedDeposit } = this.props;
		return (
			<Content>
				<ContentTitle data-testid="step-deposit-amount-title">{translate("Payment_Stake")}</ContentTitle>
				{this.getCurrencyField(translate)}
				{this.renderMinMax()}
			</Content>
		);
	}

	makeExternalPayment(newStep) {
		this.props.externalFunc.depositMFT(
			{
				language: this.getActiveLanguageCode(),
				sessionId: getUser().sessionId,
			},
			(data) => {
				this.setState({
					externalUrl: data.redirect_url,
					currentStep: newStep,
				});
			}
		);
	}

	makeExternalPaymentWithBonus(newStep, bonusId) {
		this.props.externalFunc.depositMFT(
			{
				language: this.getActiveLanguageCode(),
				sessionId: getUser().sessionId,
				claimsBonus: true,
				bonusId: bonusId,
			},
			(data) => {
				this.setState({
					externalUrl: data.redirect_url,
					currentStep: newStep,
				});
			}
		);
	}
}
